import { useTranslation } from 'react-i18next';
import type { VendorPersonType } from '@econtractor/types';
import VendorPersonAction from '../VendorPersonAction';

interface VendorPersonsTableRowProps {
    row: VendorPersonType;
    onEdit: (row: VendorPersonType) => void;
    onDelete: (row: VendorPersonType) => void;
    onOpenContacts: (row: VendorPersonType) => void;
    onSetPrimary: (row: VendorPersonType, isPrimary: boolean) => void;
}

const VendorPersonsTableRow = ({
    row,
    onEdit,
    onDelete,
    onOpenContacts,
    onSetPrimary,
}: VendorPersonsTableRowProps) => {
    const { t } = useTranslation(['Vendors']);
    const isPrimary = Boolean(row.isPrimary);

    return (
        <tr>
            <td className="primary text-center">
                <input
                    type="radio"
                    className="form-check-input m-0"
                    name={`vendor-person-primary-${row.vendorId}`}
                    checked={isPrimary}
                    title={t('persons.primaryHint')}
                    aria-label={t('persons.fields.primary')}
                    onClick={(e) => {
                        e.stopPropagation();
                        if (isPrimary) {
                            e.preventDefault();
                            onSetPrimary(row, false);
                        }
                    }}
                    onChange={() => {
                        if (!isPrimary) onSetPrimary(row, true);
                    }}
                />
            </td>
            <td
                className="name cursor-pointer"
                title={t('persons.contactsHint')}
                onClick={() => onOpenContacts(row)}
            >
                <div className="text-truncate" title={row.fullName || undefined}>
                    {row.fullName || '-'}
                </div>
                {row.description ? (
                    <small className="text-muted d-block text-truncate" title={row.description}>
                        {row.description}
                    </small>
                ) : null}
            </td>
            <td className="status">
                <span className="d-block text-truncate" title={row.position || undefined}>
                    {row.position || '-'}
                </span>
            </td>
            <td className="action">
                <VendorPersonAction row={row} onEdit={onEdit} onDelete={onDelete} />
            </td>
        </tr>
    );
};

export default VendorPersonsTableRow;
